export class Row {
  rowId: number;
  rowType: RowType;
}

export enum RowType {
  CareerSearch,
  CareerSearchSidebar,
  VideoTile,
  Section,
  TitleTile,
  SwiperSection
}
